import Dialog from '@mui/material/Dialog';
import { useSyncExternalStore } from 'react';

import { ChunkLoadErrorDisplay } from './chunk-load-error-display.js';
import {
	dismissReportedChunkLoadRecovery,
	getReportedChunkLoadError,
	getUnshownReportedChunkLoadRecovery,
	subscribeToReportedChunkLoadRecovery,
} from './chunk-load-recovery.js';

export interface StaleDeployPromptProps {
	/** Reloads the page. Defaults to a full browser reload. */
	reloadPage?: () => void;
}

/**
 * A dialog that recovers from a stale-deploy failure reported outside any error boundary: it reloads the page,
 * or asks the user to, as {@link ChunkLoadErrorDisplay} does. Renders nothing until such a failure is reported,
 * nor while an error boundary already shows one; dismissing it lets the next failure show it again.
 *
 * @param props - Optionally the reload to run.
 * @returns The dialog.
 */
export function StaleDeployPrompt({ reloadPage }: StaleDeployPromptProps) {
	const outcome = useSyncExternalStore(subscribeToReportedChunkLoadRecovery, getUnshownReportedChunkLoadRecovery);
	const error = useSyncExternalStore(subscribeToReportedChunkLoadRecovery, getReportedChunkLoadError);

	return (
		<Dialog open={outcome !== undefined} onClose={dismissReportedChunkLoadRecovery}>
			{outcome !== undefined && <ChunkLoadErrorDisplay outcome={outcome} reloadPage={reloadPage} error={error} />}
		</Dialog>
	);
}
